var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHolisticHeroBackground = function SvgHolisticHeroBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 744,
    height: 707,
    viewBox: "0 0 744 707",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M325.331 94.781c-53.17 66.69-14.088 179.272-174.691 222.963C-9.964 361.434-25.982 507.458 27.73 601.124c53.714 93.669 187.38 124.49 283.006 95.932 70.577-21.078 95.581-73.566 173.155-124.11 77.575-50.542 82.727-37.297 183.649-101.838 66.625-42.607 78.546-128.23 75.684-173.323C733.626 146.57 619.494.667 491.845.68c-55.44.007-113.441 27.534-166.514 94.102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "-.544%",
    x2: "96.657%",
    y1: "73.3%",
    y2: "28.732%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D82DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33C4FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M381.189.68c-55.44.006-113.44 27.533-166.513 94.101-53.171 66.69-14.088 179.272-174.692 222.963-14.35 3.904-27.547 8.625-39.643 14.053 47.826 27.29 103.737 42.967 163.481 42.967 176.432 0 319.458-136.742 319.458-305.42 0-13.22-.877-26.23-2.58-39.007C449.77 11.516 415.984.68 381.205.679h-.016"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "144.621%",
    x2: "6.033%",
    y1: "116.069%",
    y2: "9.652%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D82DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33C4FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.61 205.137c64.272 42.455 153.01 52.741 221.963 32.149 70.576-21.078 95.581-73.566 173.155-124.11 46.463-30.272 66.945-37.661 97.584-52.586C440.054 22.585 373.985.087 302.417.087 162.759.087 44.035 85.76.609 205.137"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "3.321%",
    x2: "119.19%",
    y1: "82.56%",
    y2: "54.482%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D82DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33C4FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.658)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M325.331 94.781c-53.17 66.69-14.088 179.272-174.691 222.963C-9.964 361.434-25.982 507.458 27.73 601.124c53.714 93.669 187.38 124.49 283.006 95.932 70.577-21.078 95.581-73.566 173.155-124.11 77.575-50.542 82.727-37.297 183.649-101.838 66.625-42.607 78.546-128.23 75.684-173.323C733.626 146.57 619.494.667 491.845.68c-55.44.007-113.441 27.534-166.514 94.102",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.655 -.658)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M381.189.68c-55.44.006-113.44 27.533-166.513 94.101-53.171 66.69-14.088 179.272-174.692 222.963-14.35 3.904-27.547 8.625-39.643 14.053 47.826 27.29 103.737 42.967 163.481 42.967 176.432 0 319.458-136.742 319.458-305.42 0-13.22-.877-26.23-2.58-39.007C449.77 11.516 415.984.68 381.205.679h-.016",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.164 459.112)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M.61 205.137c64.272 42.455 153.01 52.741 221.963 32.149 70.576-21.078 95.581-73.566 173.155-124.11 46.463-30.272 66.945-37.661 97.584-52.586C440.054 22.585 373.985.087 302.417.087 162.759.087 44.035 85.76.609 205.137",
    mask: "url(#i)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHolisticHeroBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/holistic-hero-background.8ed7c64d572305c7ac59f52c126f096c.svg";